import React, { Component } from 'react'
import Wrapper from '../common/Wrapper'
import QbmNav from './QbmNav'
import QbmBody from './QbmBody'
import PropTypes from 'prop-types'
import history from '../../history'
import { MenuItem} from 'react-bootstrap'
import { routesUrls } from '../../settings/routes'


class CustomItems extends Component {
    static contextTypes = {formatMessage: PropTypes.any}
    render() {
      const {formatMessage} = this.context;
      return <React.Fragment>
        <MenuItem
          onClick={() => {
            history.push(routesUrls.dashboard)
          }}
        >{formatMessage('navTitleDashboard')}</MenuItem>
     </React.Fragment>
    }
  }

let QbmPage = () => {
    return (
        <Wrapper renderButtonNav = {true} CustomItems={CustomItems}>
            <div className="qbm-content">
                <QbmNav initOpenItemId = "Subjects" />
                <QbmBody />
            </div>
        </Wrapper>
    )
}

export default QbmPage



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/index.js